import { Link } from "react-router-dom";

export const Shell = ({ children, testId }) => (
  <main className="min-h-screen flex items-center justify-center px-6 py-20" data-testid={testId}>
    <div className="max-w-xl w-full glass rounded-[2rem] p-8 md:p-14 text-center rise">
      {children}
      <Link to="/" className="btn-ghost inline-block mt-10" data-testid="back-home-link">Return Home</Link>
    </div>
  </main>
);
